module.exports = __webpack_public_path__ + "img/msff-map.3d9aff63.svg";